
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forwarder",
      function () {
        return require("private-next-pages/forwarder.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forwarder"])
      });
    }
  